import { Routes, Route, useLocation } from 'react-router-dom'
import Contact from './pages/Contact/Contact'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import frLocale from 'date-fns/locale/fr'
import ScheduleEditor from 'pages/ScheduleEditor/ScheduleEditor'
import { NotFound } from 'components/NotFound/NotFound'
import ConfirmHD from 'pages/Landings/ConfirmHD'
import ConflictHD from 'pages/Landings/ConflictHD'
import FamilyHDDetails from 'pages/Landings/FamilyHDDetails'

export default function App() {
  const { search } = useLocation()
  const apikey = new URLSearchParams(search).get('apikey')

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
      <div className="container">
        <Routes>
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/schedules/:entityType/:entityId"
            element={apikey ? <ScheduleEditor /> : <NotFound />}
          />
          <Route
            path="/details-declaration-famille"
            element={<FamilyHDDetails />}
          />
          <Route path="/confirmer-famille" element={<ConfirmHD />} />
          <Route path="/litige-famille" element={<ConflictHD />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </LocalizationProvider>
  )
}
